var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "verTitles",
        class: {
          "padding-b-20": _vm.accountSummaryFlow,
          "margin-b-0": !_vm.isMapPage
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "verTextContainer",
            class: {
              accountSummaryFlow: _vm.accountSummaryFlow,
              "flex-grow-center": _vm.isStepsExists
            }
          },
          [
            _vm.showTitle
              ? _c("div", { staticClass: "titles" }, [
                  _vm.isStepsExists
                    ? _c("p", { staticClass: "guidedTitle" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.SequentialVerification.GuidedVerification.Title"
                            )
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.currStepTitle))
                  ]),
                  _vm._v(" "),
                  _vm.isStepsExists
                    ? _c("p", { staticClass: "stepTitle" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.SequentialVerification.GuidedVerification.currentStepText",
                              {
                                currentStep: _vm.currentStep,
                                maxStep: _vm.maxStep
                              }
                            )
                          )
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.isMapPage
          ? _c(
              "v-icon",
              {
                staticClass: "close",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.go2verification()
                  }
                }
              },
              [_vm._v("close")]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25f0ac48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f0ac48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Verification/VerTitles.vue
// module id = null
// module chunks = 